// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset, formValueSelector } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import { flashSuccess } from 'shared/actions/UnboundFlashMessageActions';
import HForm, { PlainSelectField, TextAreaField } from 'shared/containers/portal_layout/HForm';
import { required } from 'utils/validation';
import SpinnerButton from 'shared/components/SpinnerButton';

const defaultDelayReasons = [
  'Patient Preference',
  'Post Surgery',
  'Referring Provider',
  'Difficulty Contacting Patient',
];

class _ReasonForDelayForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(formValues) {
    const reasonForDelay =
      formValues.reasonForDelay === 'Other'
        ? formValues.otherReasonForDelay
        : formValues.reasonForDelay;
    const { apiEndpoint, referralId } = this.props;
    return api
      .put(`${apiEndpoint}/referrals/${referralId}/reason_for_delay`, {
        reason_for_delay: reasonForDelay,
      })
      .then(response => {
        this.props.dispatch(flashSuccess({ message: 'Reason for delay updated.' }));
        this.props.handleSuccess();
        this.props.dispatch(reset('reasonForDelay'));
        return null;
      });
  }

  render() {
    const { reasonForDelay, delayReasons, submitting } = this.props;
    const delayReasonOptions = delayReasons.map(r => ({ value: r, label: r }));

    return (
      <HForm onSubmit={this.props.handleSubmit(this.submit)}>
        <div className="modal-header">
          <h3>Referral Reason for Delay</h3>
        </div>
        <div className="modal-body" style={{ width: 600 }}>
          <PlainSelectField
            name="reasonForDelay"
            label="Reason for Delay"
            options={delayReasonOptions}
            validate={required}
          />
          {reasonForDelay === 'Other' && (
            <TextAreaField
              name="otherReasonForDelay"
              label="Other Reason for Delay"
              validate={required}
            />
          )}
        </div>
        <div className="modal-footer">
          <SpinnerButton className="btn btn-primary" type="submit" loading={submitting}>
            Update
          </SpinnerButton>
        </div>
      </HForm>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const organizationDelayReasons =
    state.currentAgent.currentEmployment.organization.preferences.schedulingDelayReasons;
  const reasonForDelay = formValueSelector(ownProps.form)(state, 'reasonForDelay');
  return {
    reasonForDelay,
    delayReasons:
      organizationDelayReasons.length > 0 ? organizationDelayReasons : defaultDelayReasons,
  };
};

const ReasonForDelayForm = reduxForm({ form: 'reasonForDelay' })(
  connect(mapStateToProps)(_ReasonForDelayForm)
);

export { ReasonForDelayForm };
